// @atlas/contracts — a `dashboard` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
/**
 * Áttekintő (dashboard) összefoglaló — JOG-SZŰRT: minden mező csak akkor kap értéket, ha a userhez
 * tartozik a megfelelő view-jog (clients.view / accounts.view / activity_log.view); különben `null`.
 * A `null` a UI-nak azt jelenti: a widget NEM jelenik meg (helyfoglaló-mentes elrendezés).
 */
/**
 * A `recentEvents` mező KIVEZETVE: az áttekintő lapon a legutóbbi AUDIT-események blokkja
 * megszűnt (user-döntés — az eseménynaplónak külön lapja van, a kezdőlapon a napi munkát segítő két blokk
 * áll: aktuális megbeszélések + legutóbbi közlemény). A mezővel EGYÜTT megszűnt egy upstream audit-olvasás is
 * MINDEN dashboard-betöltésnél — kevesebb kérés, kisebb PII-felület.
 */
export const DashboardSchema = z.object({
    /** Ügyfelek száma (clients.view) — jog nélkül (vagy upstream-hibánál) null. */
    clientCount: z.number().nullable(),
    /** Fiókok száma (accounts.view) — jog nélkül (vagy upstream-hibánál) null. */
    accountCount: z.number().nullable(),
});
// ── Ünnepeltek csempe ────────────────────────────────────────────────────────────────────────────
/** Az előretekintő ablak (nap). */
export const CelebrationsQuerySchema = z.object({
    days: z.coerce
        .number()
        .pipe(z.union([z.literal(7), z.literal(14), z.literal(30)]))
        .default(14),
});
export const CELEBRATION_KINDS = [
    'birthday',
    'nameDay',
    'anniversary',
    'newJoiner',
    'childBirthday',
];
/**
 * Egy ünnepelt sor — MINIMÁL-projekció: nincs benne `birthDate`, SZÜLETÉSI ÉV, életkor vagy más HR-mező. A
 * `monthDay` az esemény napja (`MM-DD`); a `daysUntil` ≥ 0 az eseményig hátralévő nap, az `newJoiner`-nél NEGATÍV
 * (a belépés óta eltelt napok −1-szerese: 0 = ma lépett be).
 */
export const CelebrationItemSchema = z.object({
    kind: z.enum(CELEBRATION_KINDS),
    personId: z.string(),
    name: z.string(),
    givenName: z.string().nullable(),
    familyName: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    teamColor: z.string().nullable(),
    monthDay: z.string().regex(/^\d{2}-\d{2}$/),
    daysUntil: z.number().int(),
    /** CSAK `anniversary`: a betöltött évek száma (a belépés ténye nem érzékeny adat). */
    years: z.number().int().min(1).optional(),
    /** CSAK `childBirthday`: a gyerek KERESZTNEVE — és csak a szülő SAJÁT kezdőlapján. */
    childGivenName: z.string().optional(),
});
export const CelebrationsResponseSchema = z.object({
    /** A mai nap (`YYYY-MM-DD`, Europe/Budapest) — a BFF számolja. */
    today: z.string(),
    /** A naptár szerinti mai névnapok, munkatárstól függetlenül. */
    calendarNameDays: z.array(z.string()),
    items: z.array(CelebrationItemSchema),
});
//# sourceMappingURL=schemas.js.map